export default {
  show: {
  //  status: CampaignStatusInShow,
  //  status: CampaignStatusInList,
  },
  list: {},
};
